// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__11LGz","title":"Header_title__X2pUE","side":"Header_side__EMhyc"};